
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor04 as ObiCapacitor04Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-04.js';
 
 
 

 
 export const ObiCapacitor04 = createComponent({
   react: React,
   tagName: 'obi-capacitor-04',
   elementClass: ObiCapacitor04Element,
   events: {
     
   }
  });
 
 